interface TypingIndicatorProps {
  name?: string;
}

export function TypingIndicator({ name }: TypingIndicatorProps) {
  return (
    <div className="flex items-center gap-2 text-brand-muted text-sm">
      <div className="flex items-center gap-1">
        <span className="animate-bounce delay-0 w-2 h-2 bg-brand-muted rounded-full" />
        <span className="animate-bounce delay-100 w-2 h-2 bg-brand-muted rounded-full" style={{ animationDelay: '0.1s' }} />
        <span className="animate-bounce delay-200 w-2 h-2 bg-brand-muted rounded-full" style={{ animationDelay: '0.2s' }} />
      </div>
      <span>{name ? `${name} is typing...` : 'Typing...'}</span>
    </div>
  );
}
